module.exports = __webpack_public_path__ + "img/62_11.4963f45c.png";